var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.skeleton)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('PuSkeleton',{staticStyle:{"height":"calc(94vh - 180px)"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }